'use strict'


// verify an image has numeric height and width
module.exports = function hasDims (image) {
    return (
        image && image.width && image.height
        && !isNaN(image.width)
        && !isNaN(image.height)
    )
}
